@if (memoryService.patientId) {
  <div class="app-bar">
    @if (mode == 'mobile') {
      <app-icon-button [matMenuTriggerFor]="menu" colorVariant="transparent-white" icon="menu" size="small"/>
      <mat-menu #menu="matMenu">
        <button (click)="profile()" mat-menu-item>
          <mat-icon>person</mat-icon>
          {{ "appBar.profile" | transloco }}
        </button>
        <mat-divider/>
        <button (click)="appointments()" mat-menu-item>
          <mat-icon>accessibility_new</mat-icon>
          {{ "appBar.appointments" | transloco }}
        </button>
        <mat-divider/>
        <button (click)="logout()" mat-menu-item>
          <mat-icon>logout</mat-icon>
          {{ "appBar.logout" | transloco }}
        </button>
      </mat-menu>
    } @else {
      <app-icon-button (click)="profile()" colorVariant="transparent-white" icon="account_circle" size="small"/>
      <app-icon-button (click)="logout()" colorVariant="transparent-white" icon="logout" size="small"/>
    }
  </div>
} @else {
  <div class="app-bar">
    <app-icon-button (click)="profile()" colorVariant="transparent-white" icon="account_circle" size="small"/>
  </div>
}

<main class="app-body">
  <router-outlet/>
</main>

<footer class="app-footer">
  <a [href]="environment.privacyPolicyUrl" class="link-button" target="_blank" rel="noopener noreferrer">{{ "footer.privacy_policy" | transloco }}</a>
</footer>
